import { useMemo } from "react";
import { useFiltersContext } from "../../contexts/filtersContext";

const EMPTY_STRING_ARRAY: string[] = [];
import {
  getAvailableFilters,
  getActiveFilters,
  getFilterByKey,
  getFilterValues,
} from "../../utils/filtersStructureHelpers";
import type { TabFiltersPreset } from "./useFilterStructureType";
import type { FilterAvailableOptions } from "../../utils/filtersStructureHelpers/FiltersStructureHelpersType";

const TAB_FILTER_OPTIONS: Record<TabFiltersPreset, FilterAvailableOptions> = {
  rules: { excludeKeys: ["item", "value"] },
  statistics: { includeOnlyKey: "class_name" },
  sourceTable: { excludeKeys: ["value", "source"] },
  analysisAgent: { excludeKeys: ["item"] },
};

export const useFilterStructure = (
  presetOrOptions: TabFiltersPreset,
) => {
  const { appliedFilters, ignoredFilter, allAvailableFilters } =
    useFiltersContext();

  const options =
    typeof presetOrOptions === "string"
      ? TAB_FILTER_OPTIONS[presetOrOptions]
      : presetOrOptions;

  const availableFilters = useMemo(
    () => getAvailableFilters(allAvailableFilters, options),
    [allAvailableFilters, options],
  );

  const activeFilters = useMemo(
    () => getActiveFilters(appliedFilters, availableFilters, ignoredFilter),
    [appliedFilters, availableFilters, ignoredFilter],
  );

  const classNameFilter = useMemo(
    () => getFilterByKey(activeFilters, "class_name"),
    [activeFilters],
  );

  const rawClassNameValues = useMemo(
    () => getFilterValues(activeFilters, "class_name"),
    [activeFilters],
  );
  const classNameFilterValues = useMemo(() => {
    if (rawClassNameValues.length === 0) return EMPTY_STRING_ARRAY;
    return rawClassNameValues;
  }, [rawClassNameValues]);

  return {
    availableFilters,
    activeFilters,
    classNameFilter,
    classNameFilterValues,
  };
};
